import xhr from 'Common/utils/xhr'
import { getVideoUrl } from '../../endpoints'

const getVideo = videoParam => {
  return xhr({
    url: getVideoUrl(videoParam),
    method: 'GET',
  })
}

export default getVideo
